// src/theme/tokens.js

export const THEME_STORAGE_KEY = "neo-theme-mode";

export const themeTokens = {
  light: {
    mode: "light",
    colorScheme: "light",
    bg: "#eef2f7",
    bgElevated: "#f8fafc",
    surface: "rgba(255,255,255,0.82)",
    surfaceStrong: "#ffffff",
    surfaceMuted: "#f4f7fb",
    border: "rgba(15, 23, 42, 0.08)",
    borderStrong: "rgba(15, 23, 42, 0.14)",
    text: "#0f172a",
    textSoft: "#475569",
    textMuted: "#64748b",
    accent: "#2f80ed",
    accentSoft: "rgba(47, 128, 237, 0.14)",
    success: "#1f9d55",
    successSoft: "rgba(31, 157, 85, 0.12)",
    warn: "#b7791f",
    warnSoft: "rgba(183, 121, 31, 0.14)",
    danger: "#d64545",
    dangerSoft: "rgba(214, 69, 69, 0.12)",
    shadow: "0 20px 48px rgba(15, 23, 42, 0.08)",
    shadowSoft: "0 8px 24px rgba(15, 23, 42, 0.06)",
    glow: "0 0 0 1px rgba(47, 128, 237, 0.08), 0 0 32px rgba(47, 128, 237, 0.14)",
  },

  dark: {
    mode: "dark",
    colorScheme: "dark",
    bg: "#07111f",
    bgElevated: "#0b1628",
    surface: "rgba(10,18,32,0.76)",
    surfaceStrong: "#0f1b30",
    surfaceMuted: "#13233c",
    border: "rgba(148, 163, 184, 0.18)",
    borderStrong: "rgba(148, 163, 184, 0.26)",
    text: "#e5edf7",
    textSoft: "#c5d2e3",
    textMuted: "#8ea2bd",
    accent: "#56a3ff",
    accentSoft: "rgba(86, 163, 255, 0.16)",
    success: "#3ddc97",
    successSoft: "rgba(61, 220, 151, 0.14)",
    warn: "#f5b942",
    warnSoft: "rgba(245, 185, 66, 0.16)",
    danger: "#ff6b6b",
    dangerSoft: "rgba(255, 107, 107, 0.14)",
    shadow: "0 24px 56px rgba(0, 0, 0, 0.42)",
    shadowSoft: "0 12px 28px rgba(0, 0, 0, 0.3)",
    glow: "0 0 0 1px rgba(86, 163, 255, 0.14), 0 0 40px rgba(86, 163, 255, 0.18)",
  },
};